/**
 * The data state is split into mutable and immutable state. Both may come pre-loaded from the server or the URL,
 * but only the mutable state should be altered during the lifetime of the app. The rest of the app relies on the
 * immutability of the immutable part of the data state.
 *
 * */


import { SET_IMMUTABLE_APP_DATA, SET_ROW_DATA, UPDATE_ROW_DATA } from "../actions/data";
import { deepCopyObject } from "../../../utils/deepCopy";

export const initialImmutableBaseAppData = {
    fields: [],
    fieldTypes: {},
    fieldWidths: {},
    rowKeys: [],
    valueFormatterMapping: {},
    filterDownloadUrl: null,  // lives here because it's shared by a number of things.
};

export function immutableBaseData(state = initialImmutableBaseAppData, action) {
    switch (action.type) {

        case SET_IMMUTABLE_APP_DATA:
            return {
                ...state,
                fields: action.fields,
                fieldTypes: action.fieldTypes,
                fieldWidths: action.fieldWidths,
                rowKeys: action.rowKeys,
                valueFormatterMapping: action.valueFormatterMapping,
                filterDownloadUrl: action.filterDownloadUrl,
            };

        default:
            return state
    }
}

export const initialMutableBaseAppData = {
    rows: {},
};

export function mutableBaseData(state = initialMutableBaseAppData, action) {
    switch (action.type) {

        case SET_ROW_DATA:
            return {
                ...state,
                rows: action.rows,
            };

        case UPDATE_ROW_DATA:

            const newRows = deepCopyObject(state.rows);
            newRows[action.rowKey][action.field] = action.value;

            return {
                ...state,
                rows: newRows,
            };

        default:
            return state
    }
}

